const brand = {
  brandProfile: "Профиль бренда",
  companyName: "Название компании",
  uploadLogo: "Загрузить логотип",
  removeLogo: "Удалить логотип",
  tagline: "Цифровая подпись",
  brandColors: "Цвета бренда",
  primary: "Основной",
  secondary: "Вторичный",
  tertiary: "Третичный",
  brand: "Бренд",
} as const;
export default brand;
